<template>
  <div id="addPrinter" :class="{
    ipConnectAdd: type == '4'
  }">
    <el-dialog :title="type !== '4' ? $t('AddPrinter') : $t('ConnectByIPLAN')" :visible.sync="dialogVisible"
      :close-on-click-modal="false" :destroy-on-close="true" :lock-scroll="false" :modal-append-to-body="false"
      @close="viewClose">
      <div class="printer">
        <div class="netConnect" v-show="type == '1'">
          <div class="find" v-show="step == '1'">
            <img class="findImg" :src="getImg" />
            <span class="findLabel">{{ $t("FindingDevices") }}</span>
            <span class="findTip1">{{ $t("LANConnectionNote1") }}</span>
            <span class="findTip2">{{ $t("LANConnectionNote2") }}</span>
          </div>
          <div class="result" v-show="step == '2'">
            <div class="haveRes" v-show="havePrinter">
              <div class="title">
                <div class="titleLeft">
                  {{ $t("lan_connection") }} ({{ lanPrinterList.length }})
                </div>
                <div class="titleRight">
                  <div class="btn" @click="reSearch">{{ $t("refresh") }}</div>
                </div>
              </div>
              <div class="printerList" style="margin-bottom: 25px">
                <div class="printerItem" v-for="(item, index) of lanPrinterList" :key="index">
                  <div class="itemTop">
                    <div class="topLeft">
                      <div class="name" :title="item.name">{{ item.name }}</div>
                      <div class="model" :title="item.model">{{ item.model }}</div>
                      <div class="lan">
                        <img src="../../../assets/imgs/lanIcon.png" />
                        <span>{{ $t("LAN") }}</span>
                      </div>
                      <div class="ip">{{ item.ip && `IP: ${item.ip}` }}</div>
                      <!-- <div class="ip" v-show="item.ip">IP: {{ item.ip }} {{ item.ip && `IP: ${item.ip}` }}</div> -->
                    </div>
                    <div class="topRight">
                      <img :src="formmatImg(item)" />
                    </div>
                  </div>
                  <div class="itemBottom" @click="lanThrottle(item)">
                    {{ $t("ConnectPrinter") }}
                  </div>
                </div>
              </div>
              <div class="title">
                <div class="titleLeft">
                  <span style="margin-right: 24px">{{ $t("cloud_printer_connection") }} ({{
                    cloudPrinterList.length
                    }})</span>
                  <span class="tip" style="font-family: AlibabaPuHuiTi-3-55-Regular;" v-show="!token">{{
                    $t("LoginToUse") }}，<span class="link" @click="tologin()">{{ $t("LoginNow") }}</span></span>
                  <span class="tipLogin" style="font-family: AlibabaPuHuiTi-3-55-Regular;" v-show="token">{{
                    $t("LoggedIn") }}</span>
                </div>
                <div class="titleRight">
                  <!-- <div class="btn" @click="reSearch">{{ $t("refresh") }}</div> -->
                </div>
              </div>
              <div class="printerList">
                <div class="printerItem" v-for="(item, index) of cloudPrinterList" :key="index">
                  <div class="itemTop">
                    <div class="topLeft">
                      <div class="name" :title="item.name">{{ item.name }}</div>
                      <div class="model" :title="item.model">{{ item.model }}</div>
                      <div class="cn">{{ item.cn }}</div>
                    </div>
                    <div class="topRight">
                      <img :src="formmatImg(item)" />
                    </div>
                  </div>
                  <div class="itemBottom" :style="{
                    background: !token ? '#BDD6FC' : '',
                    cursor: !token ? 'not-allowed' : ''
                  }" @click="connectCloud(item)">
                    {{ $t("ConnectPrinter") }}
                  </div>
                </div>
              </div>
              <!-- <div class="tips">
                <div class="tip1">
                  1.仅能发现与当前设备在同一局域网下的打印机
                </div>
                <div class="tip2">2.仅支持2.4G Hz Wi-Fi</div>
              </div> -->
            </div>
            <div class="nohaveRes" v-show="!havePrinter">
              <img class="findImg" src="../../../assets/imgs/noPrinter.png" />
              <span class="findLabel">{{ $t("no_device_found") }}</span>
              <span class="findTip1">{{ $t("LANConnectionNote1") }}</span>
              <span class="findTip2">{{ $t("LANConnectionNote2") }}</span>
              <!-- <img class="reScan" src="../../../assets/imgs/reScan.png" @click="reSearch"/> -->
            </div>
          </div>
        </div>
        <div class="CnConnect" v-show="type == '2'" @keyup.enter="addCn">
          <div class="cnMain">
            <div class="cnImg">
              <img src="../../../assets/imgs/CNPrinter.png" />
            </div>
            <div class="cnTip">
              <div class="label" style="margin-top: 46px">
                {{ $t("Step1") }}
              </div>
              <div class="label">{{ $t("Step2") }}</div>
              <div class="label">{{ $t("Step3") }}</div>
              <div class="label">
                {{ $t("Step4") }}
              </div>
            </div>
          </div>
          <div class="cnCodeTitle">{{ $t("EnterDeviceCN") }}</div>
          <div class="cnCodeBox">
            <div class="code-item" v-for="item in [0, 1, 2, 3]" :key="item" :class="codeValue.length == item && inputFocus ? 'code-item-active' : ''
              ">
              {{ codeValue[item] }}
            </div>
            <div class="line"></div>
            <div class="code-item" v-for="item in [4, 5, 6, 7]" :key="item" :class="codeValue.length == item && inputFocus ? 'code-item-active' : ''
              ">
              {{ codeValue[item] }}
            </div>
            <div class="line"></div>
            <div class="code-item" v-for="item in [8, 9, 10, 11]" :key="item" :class="codeValue.length == item && inputFocus ? 'code-item-active' : ''
              ">
              {{ codeValue[item] }}
            </div>
            <div class="line"></div>
            <div class="code-item" v-for="item in [12, 13, 14, 15]" :key="item" :class="codeValue.length == item && inputFocus ? 'code-item-active' : ''
              ">
              {{ codeValue[item] }}
            </div>
            <el-input class="input-code" :value="codeValue" :maxlength="16" @input="codeInputChange"
              @blur="codeInputBlur" @focus="codeInputFocus" @keydown="handleKeyDown()">
            </el-input>
          </div>
        </div>
        <div class="AppConnect" v-if="type == '3'">
          <div class="imgBox">
            <img src="../../../assets/imgs/addCloudPrinter.png" />
          </div>
          <div class="contentBox">
            <div class="label" style="margin-bottom: 12px">
              1.下载纵维立方 App
            </div>
            <div class="qrBox">
              <div class="qrItem">
                <vue-qr :text="androidQrUrl" :margin="0" :size="100"> </vue-qr>
                <span>Android</span>
              </div>
              <div class="qrItem">
                <vue-qr :text="iosQrUrl" :margin="0" :size="100"> </vue-qr>
                <span>iOS</span>
              </div>
            </div>
            <div class="label">
              2.注册并登录账号，保证与切片软件登录同一账号
            </div>
            <div class="label">
              3.查看打印机，设置>云平台>更多信息，查看打印机的 CN 码及绑定二维码
            </div>
            <div class="label">4.使用纵维立方 App 扫码并绑定设备</div>
          </div>
        </div>
        <div class="IpConnect" v-if="type == '4'">
          <div class="search" @keyup.enter="createLanSlice">
            <div class="ipConnectTitle">{{ $t('enter_ip_address') }}</div>
            <el-input v-model="IPInfo.address" size="mini" :placeholder="$t('EnterIPAddress')" style="width: 100%"
              @input="handleInput" class="no_number"></el-input>
            <!-- <div class="priBtn" @click="createLanSlice" element-loading-spinner="el-icon-loading" v-loading="ipLoading">{{
              $t('confirm') }}</div> -->
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="tip" v-show="type == '1' && step == '2'">
          <span>{{ $t("CantFindPrinter")
            }}<span class="link" @click="reSearch">{{ $t("Retry") }}</span>
            <!-- <span class="nomal">{{ $t("or") }}</span
            ><span class="link">{{ $t("ViewWiki") }}</span> -->
          </span>
        </div>
        <div class="lanTip" v-show="type == '4'">
          <span>{{ $t("LANDiscoveryNote1") }}
          </span>
          <span style="margin-bottom: 24px">{{ $t("LANDiscoveryNote2") }}
          </span>
        </div>
        <div class="footerOperate" v-show="type == '1'">
          <div class="operateLeft">{{ $t("OtherConnectionMethods") }}</div>
          <div class="operateRight">
            <div class="priBtn" @click="handleType('2')" style="margin-right: 8px" :class="!token ? 'disBtn' : ''">
              {{ $t("ConnectByCN") }}
            </div>
            <div class="priBtn" @click="handleType('4')">{{ $t('ConnectByIP') }}</div>
          </div>
        </div>
        <div class="footerOperate" v-show="type == '2' || type == '4'">
          <div class="operateLeft">
            <!-- 新增ip直连当前连接状态 -->
            <span v-show="type == '4' && ipConnectState" :class="{
              ipConnectLoading: ipConnectState == 'loading',
              ipConnectError: ipConnectState == 'error'
            }">{{ getIpConnectTips(ipConnectState) }}</span>
          </div>
          <div class="operateRight">
            <el-button size="mini" @click="handleType('1')" style="border-radius: 16px">{{ $t("back") }}</el-button>
            <el-button size="mini" v-show="type == '4'" type="primary" class="priBtn" @click="createLanSlice"
              :disabled="ipConnectState == 'loading' || !IPInfo.address.trim()">
              {{ $t('OK') }}</el-button>
            <el-button v-show="type == '2'" size="mini" type="primary" @click="addCn()" :disabled="!codeValue" style="border-radius: 16px">{{
              $t("OK") }}</el-button>
          </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VueQr from "vue-qr";
import { search_device, device_notify } from "../../../api/slicer/printer.js";
import { addprinter, getInfo } from "../../../api/network/printer.js";
import { mapGetters } from "vuex";
import {
  getQueryParam,
  generateSecureRandomString,
  decryptText,
  throttle
} from "@/utils/common";
import { account } from "@/utils/account";
import { formmatImg } from "@/utils/common.js";
import {
  createMqttLan,
  setMqttLanConnct,
  publish
} from "@/utils/lanMqtt";
import { createApplication } from '@/utils/host_application.js';

export default {
  name: "addPrinter",
  components: { VueQr },
  props: {
    visible: Boolean
  },
  watch: {
    GET_TOKEN: function (val) {
      this.token = val;
    },
    visible: function (val) {
      this.dialogVisible = val;
    },
    dialogVisible: function (val) {
      if (val) {
        this.type = "1";
        this.step = "1";
        this.havePrinter = false;
        this.lanPrinterList = [];
        this.cloudPrinterList = [];
        this.token = this.$store.getters.GET_TOKEN;
        this.codeValue = "";
        this.inputFocus = false;
        this.IPInfo = {
          address: "",
          printer: {
            name: "",
            model: "",
            cn: "",
            img: ""
          },
          status: 0 //0初始 1搜索中 2搜索有打印机 3搜索无打印机
        };

        this.$nextTick(async () => {
          await device_notify(this.setPrinter);

          search_device("fdm", 2, 5000);

        });
      } else {
        // 中止连接请求
        this.ipController?.abort();
        this.ipConnectState = ''
      }
    }
  },
  computed: {
    ...mapGetters(["GET_LAN_PRINTER_LIST", "GET_TOKEN"]),
    getImg () {
      return !this.$store.getters.GET_IS_DARK
        ? require('@/assets/imgs/search.png')
        : require('@/assets/dark/search.webp')
    },
    getIpConnectTips () {
      return str => {
        if (!str) return ''
        return str === 'loading' ? this.$t('connecting') : this.$t('connection_error')
      }
    }
  },
  data () {
    return {
      token: "",
      dialogVisible: false,
      type: "1", //1 网络 2 cn码 3 app扫码 4 ip连接
      step: "1", //1 搜索打印机 2 有搜索结果
      havePrinter: false, //是否有打印机
      lanPrinterList: [],
      cloudPrinterList: [],
      androidQrUrl: "https://www.baidu.com",
      iosQrUrl: "https://www.baidu.com",
      codeValue: "",
      inputFocus: false,
      IPInfo: {
        address: "",
        printer: {
          name: "",
          model: "",
          cn: "",
          img: ""
        },
        status: 0 //0初始 1搜索中 2搜索有打印机 3搜索无打印机
      },
      ipController: null,
      ipConnectState: null // 'loading': 查找中...，'error' 未发现设备
    };
  },
  activated () { },
  deactivated () {
    this.viewClose();
  },
  methods: {
    handleInput (value) {
      const filteredValue = value.replace(/[^0-9.]/g, '');
      this.$nextTick(() => {
        this.IPInfo.address = filteredValue;
      });
    },
    //  通过ip连接
    async connectMqtt (ctrlInfoUrl, token, uuid, name) {
      let did = await createApplication().config_read('pc_device_id')
      let ts = Date.now()
      let nonce = generateSecureRandomString(6)
      let resData = await this.getFetch(ctrlInfoUrl + `?ts=${ts}&nonce=${nonce}&sign=${encodeURI(encodeURIComponent(this.$md5(this.$md5(token.slice(0, 16)) + ts + nonce)))}&did=${did}`, {
        method: 'POST',
      });
      if (resData.code !== 200) {
        this.$message.error(`${this.$t(resData.code === 19002 ? 'pinter_limit_reached' : 'connection_error')}(Code:${resData.code})`);
        return false
      }
      const data = decryptText(
        resData.data.info,
        token.slice(16, 32),
        resData.data.token
      );

      const mqtt = {
        ...data,
        uuid, // 唯一值
        name,
        status: "",
        retryCount: this.$global.lanCount,// 重连次数
        haveTip: 0, // 连接显示
        isConnect: true
      };
      this.$store.dispatch("SET_LAN_MQTT", mqtt);
      this.$store.commit("SET_PRINTER_TYPE", "lan");


      // 重置回显--业务
      this.$store.commit("DEL_CUR_PRINTER");
      this.$store.commit("DEL_CUR_TASK");
      this.$store.commit("SET_PRINTER_TYPE", "lan");
      let curPrinter = this.$store.getters.GET_CUR_PRINTER || {};
      curPrinter.deviceId = mqtt?.deviceId;
      curPrinter.img = formmatImg(mqtt?.modelName);
      curPrinter.name = mqtt?.name;
      curPrinter.model = mqtt?.modelName;
      curPrinter.ip = mqtt?.ip;
      curPrinter.version = {};
      curPrinter.version.firmware_version = mqtt?.version?.firmware_version || '';
      curPrinter.status = '';
      curPrinter.project = undefined;
      this.$store.commit('SET_CUR_PRINTER', curPrinter);

      // 创建连接
      await createMqttLan(mqtt.uuid)
      setMqttLanConnct(mqtt);

      //  创建成功
      this.$message.success(this.$t('device_add_success'))

      // 防止重复点击
      this.$store.commit("SET_LAN_LAYOUT_LOADING", true);
      setTimeout(() => {
        this.$store.commit("SET_LAN_LAYOUT_LOADING", false);
      }, 1000)

      // 处理列表
      let LanList = JSON.parse(
        JSON.stringify(this.$store.getters.GET_LAN_PRINTER_LIST)
      );
      if (LanList.findIndex(item => item.uuid == mqtt.uuid) == -1) {
        LanList.unshift(mqtt);
        this.$store.dispatch("SET_LAN_PRINTER_LIST", LanList);
      }

      this.dialogVisible = false;
      this.$router.push("/workbench");
    },
    warningMessage (uuid) {
      //  判断当前固件是否返回uuid
      if (!uuid) {
        this.$message.warning(this.$t('firmware_update_required'))
        return true
      }
      let LanList = JSON.parse(
        JSON.stringify(this.$store.getters.GET_LAN_PRINTER_LIST)
      );

      //  判断当前添加的打印机列表是否有相同uuid的机器
      const uuidIndex = LanList.findIndex(item => item.uuid == uuid);
      if (uuidIndex != -1) {
        this.$message.warning(this.$t('device_exists'))
        return true
      }
      return false
    },
    async createLanSlice () {
      if (!this.IPInfo.address)return
      this.ipController = new AbortController();
      const { signal } = this.ipController;
      const ip = this.IPInfo.address.trim()
      //  判断输入的值是否为ip
      if (!this.$common.isValidIPv4(ip)) {
        return this.$message.warning(this.$t('invalid_ip_format'))
      }
      //  请求机器服务报错
      this.ipConnectState = 'loading'
      let res = await this.getFetch(`http://${ip}:18910/info`, { signal });
      this.ipConnectState = ''
      if (!res) return
      const { ctrlInfoUrl, token, usn, deviceName } = res;
      if (this.warningMessage(usn)) return 
      this.connectMqtt(ctrlInfoUrl, token, usn, deviceName);
    },
    tologin () {
      account.login();
    },
    formmatImg (item) {
      return this.$common.formmatImg(item.model);
    },
    reSearch () {
      search_device("fdm", 2, 5000);
      this.cloudPrinterList = [];
      this.lanPrinterList = [];
      this.step = "1";
      this.havePrinter = false;
    },
    setPrinter (p1, p2, p3, p4) {
      if (p4 == 1) {
        if (
          this.cloudPrinterList.length == 0 &&
          this.lanPrinterList.length == 0
        ) {
          this.step = "2";
          this.havePrinter = false;
        }
        return false;
      }
      const urlParams = new URLSearchParams(p3);
      let obj = {
        name: urlParams.get('deviceName'),
        model: urlParams.get("modelName"),
        cn: getQueryParam(p3, "cn"),
        img: "",
        url: p3
      };
      const ctrlType = getQueryParam(p3, "ctrlType");
      if (ctrlType == "lan") {
        obj.uuid = p1; //唯一值局域网
        obj.ip = getQueryParam(p3, "ip");
        if (p4 == 0) {
          // 去重
          let res1 = this.lanPrinterList.find((i) => i.uuid === p1);
          let res2 = this.GET_LAN_PRINTER_LIST.find((i) => i.uuid === p1);
          if (res1 || res2) return false;
          this.lanPrinterList.push(obj);
          this.step = "2";
          this.havePrinter = true;
        }
      } else {
        if (p4 == 0) {
          let flag = this.cloudPrinterList.findIndex((item) => {
            return item.cn == getQueryParam(p3, "cn");
          });
          if (flag != -1) return false;
          this.cloudPrinterList.push(obj);
          this.step = "2";
          this.havePrinter = true;
          console.log(this.cloudPrinterList, "this.cloudPrinterList");
        }
      }
    },
    viewClose () {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    },
    handleType (val) {
      //  ip直连和返回按钮不需要登录信息
      const list = ['1', '4']
      if (!this.token && !list.includes(val)) {
        return;
      }
      // ip直连，点击返回按钮需要重新刷新列表
      if (this.type == 4) {
        // 中止连接请求
        this.ipController?.abort();
        this.ipConnectState = ''
        this.reSearch()
      }
      this.type = val;
    },
    // 验证码输入框
    codeInputChange (e) {
      if (e) {
        // 判断输入内容是否为数字
        if (/^[A-Za-z0-9]+$/.test(e)) {
          this.codeValue = e.toUpperCase();
        }
      } else {
        this.codeValue = "";
      }
    },
    // 验证码输入框失去焦点
    codeInputBlur () {
      this.inputFocus = false;
    },
    // 验证码输入框获取到焦点
    codeInputFocus () {
      this.inputFocus = true;
    },
    addCn () {
      if (!this.codeValue) return;
      if (this.codeValue.length < 16) {
        this.$message.warning(this.$t("enter_full_cn_code"));
        return;
      }
      addprinter({ key: this.codeValue, support_fdm: "1" }).then((res) => {
        if (res.code == 1) {
          let id = res.data?.id;
          this.$store.commit("SET_PRINTER_TYPE", "cloud");
          this.dialogVisible = false;
          this.$emit("cnSubmit", id);
        }
      });
    },
    connectCloud (item) {
      //  添加是否订阅成功
      addprinter({ key: item.cn, support_fdm: "1" }).then((res) => {
        if (res.code == 1) {
          let id = res.data?.id;
          this.$store.commit("SET_PRINTER_TYPE", "cloud");
          this.dialogVisible = false;
          this.$emit("cnSubmit", id);
          //  创建成功
          this.$message.success(this.$t('device_add_success'))
        }
      })
    },
    lanThrottle: throttle(function () {
      let args = arguments;
      this.connectLan(...args)
    }, 1000 * 10),
    async connectLan (item) {
      let { ctrlInfoUrl, token } = await this.getFetch(item.url);
      if (this.warningMessage(item.uuid)) return
      await this.connectMqtt(ctrlInfoUrl, token, item.uuid, item.name);
    },
    async getFetch (url, options) {
      try {
        let response = await fetch(url, options);
        // if (!response.ok) {
        //   this.$message.error(this.$t('connection_error'));
        //   throw new Error('connection_error');
        // }
        return await response.json();
      } catch (e) {
        this.ipConnectState = ''
        if (e.name !== 'AbortError') {
          this.ipConnectState = 'error'
          this.$message.error(this.$t('connection_error'));
          throw new Error('connection_error');
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ipConnectAdd {
  :deep(.el-dialog) {
    width: 560px !important;
  }

  :deep(.el-dialog__body) {
    min-height: unset !important;
  }

  :deep(.el-dialog__footer) {
    padding: 0 20px 23px !important;
    -webkit-user-select: none;
  }
}

#addPrinter {
  :deep(.el-dialog__header) {
    text-align: center;
    padding-top: 10px;

    .el-dialog__title {
      font-family: AlibabaPuHuiTi-3-85-Bold;
      font-weight: normal;
      font-size: 13px;
      line-height: 18px;
    }

    .el-dialog__headerbtn {
      top: 10px;
    }
  }

  :deep(.el-dialog__body) {
    min-height: 415px;
    padding: 0px;
  }

  :deep(.el-dialog__footer) {
    padding-top: 10px;
  }

  :deep(.el-dialog) {
    width: 800px;
    box-sizing: border-box;
  }

  .printer {
    .netConnect {
      .find {
        padding: 24px 24px 54px 24px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .findImg {
          width: 240px;
          height: 180px;
          margin-bottom: 16px;
        }

        .findLabel {
          height: 22px;
          font-family: AlibabaPuHuiTi-3-85-Bold;
          font-weight: bold;
          font-size: 15px;
          color: var(--VI-color);
          line-height: 22px;
          margin-bottom: 16px;
        }

        .findTip1 {
          height: 22px;

          font-weight: normal;
          font-size: 15px;
          color: var(--second-text-color);
          line-height: 22px;
          margin-bottom: 8px;
        }

        .findTip2 {
          height: 22px;

          font-weight: normal;
          font-size: 15px;
          color: var(--second-text-color);
          line-height: 22px;
        }
      }

      .result {
        .haveRes {
          padding: 20px 20px 0px 20px;
          display: flex;
          flex-direction: column;

          // align-items: center;
          .title {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .titleLeft {
              font-family: AlibabaPuHuiTi-3-75-SemiBold;
              height: 24px;
              font-size: 13px;
              color: var(--second-text-color);
              line-height: 24px;

              .tip {
                font-weight: normal;
                color: var(--first-text-color);

                .link {
                  color: var(--VI-color);
                  cursor: pointer;
                }
              }

              .tipLogin {
                font-weight: normal;
                color: #72C240;
              }
            }
          }

          .printerList {
            display: flex;
            padding: 12px 0px 12px 8px;
            width: 100%;
            overflow-x: scroll;

            .printerItem {
              // flex: 1;
              width: 254px;
              // height: 128px;
              background: var(--dialog-background-color);
              border-radius: 12px 12px 12px 12px;
              border: 1px solid var(--VI-color);
              box-sizing: border-box;
              margin-right: 16px;

              .itemTop {
                display: flex;
                justify-content: space-between;
                width: 100%;
                padding: 14px 8px 0px 14px;

                .topLeft {
                  .name {
                    width: 140px;
                    height: 20px;
                    font-family: AlibabaPuHuiTi-3-75-SemiBold;
                    font-weight: normal;
                    font-size: 14px;
                    color: var(--second-text-color);
                    line-height: 20px;
                    white-space: nowrap;
                    /* 确保文本在一行内显示 */
                    overflow: hidden;
                    /* 隐藏超出容器的内容 */
                    text-overflow: ellipsis;
                    /* 使用省略号表示被截断的文本 */
                    margin-bottom: 4px;
                  }

                  .model {
                    height: 18px;
                    font-size: 14px;
                    color: var(--second-text-color);
                    line-height: 18px;
                    white-space: nowrap;
                    /* 确保文本在一行内显示 */
                    overflow: hidden;
                    /* 隐藏超出容器的内容 */
                    text-overflow: ellipsis;
                    /* 使用省略号表示被截断的文本 */
                    max-width: 120px;
                    margin-bottom: 8px;
                  }

                  .cn {

                    font-weight: normal;
                    font-size: 12px;
                    color: #438dff;
                    line-height: 14px;
                    margin-top: 28px;
                  }

                  .lan {
                    display: flex;
                    align-items: center;
                    max-width: 150px;

                    img {
                      width: 18px;
                      height: 18px;
                      margin-right: 4px;
                    }

                    span {
                      height: 20px;

                      font-weight: normal;
                      font-size: 14px;
                      color: var(--VI-color);
                      line-height: 20px;
                      white-space: nowrap;
                      /* 确保文本在一行内显示 */
                      overflow: hidden;
                      /* 隐藏超出容器的内容 */
                      text-overflow: ellipsis;
                      /* 使用省略号表示被截断的文本 */
                    }
                  }

                  .ip {
                    height: 20px;

                    font-weight: normal;
                    font-size: 14px;
                    color: var(--VI-color);
                    line-height: 20px;
                  }

                  // .cn {
                  //   height: 18px;
                  //   
                  //   font-weight: normal;
                  //   font-size: 13px;
                  //   color: #262626;
                  //   line-height: 18px;
                  //   margin-top: 8px;
                  // }
                }

                .topRight {
                  img {
                    width: 80px;
                    height: 80px;
                    border-radius: 0px 0px 0px 0px;
                    object-fit: contain;
                  }
                }
              }

              .itemBottom {
                margin-top: 10px;
                width: 100%;
                height: 24px;
                background: #398dff;
                border-radius: 0px 0px 10px 10px;
                line-height: 24px;
                text-align: center;
                color: #ffffff;
                cursor: pointer;
                // .priBtn {
                //   width: 100%;
                // }
              }
            }
          }

          .tips {
            .tip1 {
              height: 18px;

              font-weight: normal;
              font-size: 13px;
              color: var(--first-text-color);
              line-height: 18px;
              margin-top: 12px;
            }

            .tip2 {
              height: 18px;

              font-weight: normal;
              font-size: 13px;
              color: var(--first-text-color);
              line-height: 18px;
              margin-top: 8px;
            }
          }
        }

        .nohaveRes {
          padding: 24px 24px 11px 24px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .findImg {
            width: 383px;
            height: 180px;
            margin-bottom: 16px;
          }

          .findLabel {
            height: 22px;
            font-family: AlibabaPuHuiTi-3-85-Bold;
            font-weight: bold;
            font-size: 15px;
            color: var(--second-text-color);
            line-height: 22px;
            margin-bottom: 16px;
          }

          .findTip1 {
            height: 22px;

            font-weight: normal;
            font-size: 15px;
            color: var(--second-text-color);
            line-height: 22px;
            margin-bottom: 8px;
          }

          .findTip2 {
            height: 22px;

            font-weight: normal;
            font-size: 15px;
            color: var(--second-text-color);
            line-height: 22px;
            margin-bottom: 24px;
          }

          .reScan {
            width: 110px;
            height: 28px;
            cursor: pointer;
          }
        }
      }
    }

    .CnConnect {
      padding: 20px 42px;

      .cnMain {
        display: flex;

        .cnImg {
          width: 240px;
          height: 180px;
          margin-right: 16px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .cnTip {
          width: 460px;

          .label {

            font-weight: normal;
            font-size: 15px;
            color: var(--second-text-color);
            line-height: 21px;
            margin-bottom: 8px;
          }
        }
      }

      .cnCodeTitle {
        height: 21px;
        font-family: AlibabaPuHuiTi-3-85-Bold;
        font-size: 15px;
        color: var(--second-text-color);
        line-height: 21px;
        margin-top: 18px;
        margin-bottom: 12px;
      }

      .cnCodeBox {
        position: relative;
        display: flex;
        align-items: center;
        margin-bottom: 40px;

        .line {
          width: 16px;
          height: 1px;
          border-radius: 0px 0px 0px 0px;
          background: var(--workench-add-line);
          margin-right: 8px;
        }

        .code-item {
          width: 32px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          background: var(--loading-background-color);
          margin-right: 8px;


          font-weight: normal;
          font-size: 24px;
          color: #398dff;
          line-height: 34px;
          vertical-align: middle;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .code-item-active {
          border: 1px solid #438dff;
          box-sizing: border-box;
        }

        .input-code {
          position: absolute;

          :deep(.el-input__inner) {
            width: 716px;
            height: 48px;
            background-color: transparent;
            border: none;
            color: transparent;
          }
        }
      }
    }

    .AppConnect {
      padding: 24px 40px;
      display: flex;

      .imgBox {
        width: 240px;
        height: 180px;
        margin-right: 16px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .contentBox {
        width: 460px;

        .label {

          font-weight: normal;
          font-size: 15px;
          color: var(--second-text-color);
          line-height: 21px;
          margin-bottom: 24px;
        }

        .qrBox {
          display: flex;
          margin-bottom: 24px;

          .qrItem {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 24px;

            span {
              height: 21px;

              font-weight: normal;
              font-size: 15px;
              color: #464646;
              line-height: 21px;
              margin-top: 4px;
            }
          }
        }
      }
    }

    .IpConnect {
      padding: 16px 24px;

      .ipConnectTitle {
        font-size: 13px;
        color: var(--first-text-color);
        line-height: 18px;
        margin-bottom: 8px;
      }

      .priBtn {
        padding: 3px 16px;
        line-height: 18px;
        margin-left: 8px;
      }

      :deep(.el-input--mini .el-input__inner) {
        height: 30px;
        line-height: 30px;
      }
    }
  }

  .tip {
    text-align: left;
    margin-top: 35px;
    height: 18px;
    font-family: AlibabaPuHuiTi-3-85-Bold;
    font-size: 13px;
    color: var(--first-text-color);
    line-height: 18px;
    margin-bottom: 7px;

    .link {
      color: var(--VI-color);
      cursor: pointer;
      margin: 0 8px;
      font-family: AlibabaPuHuiTi-3-55-Bold;
    }

    .nomal {
      font-weight: normal;
      color: var(--first-text-color);
    }
  }

  .lanTip {
    display: flex;
    flex-direction: column;
    text-align: left;

    span {
      font-weight: normal;
      font-size: 15px;
      color: var(--second-text-color);
      line-height: 21px;
      margin-bottom: 4px;
    }
  }

  .footerOperate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 28px;

    .operateLeft {
      height: 28px;

      font-weight: normal;
      font-size: 13px;
      color: var(--first-text-color);
      line-height: 28px;

      .ipConnectError {
        color: #FF6700;
      }

      .ipConnectLoading {
        color: var(--VI-color);
      }
    }

    .operateRight {
      display: flex;
      align-items: center;

      .priBtn {
        border-radius: 16px 16px 16px 16px;
      }

      .disBtn {
        background: var(--VI-disColor);
        cursor: not-allowed;
      }
    }
  }
}

::v-deep .no_number input::-webkit-inner-spin-button,
::v-deep .no_number input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}

::v-deep .no_number input[type='number'] {
  appearance: textfield;
}

.IpConnect {
  ::v-deep .el-loading-spinner {
    top: 100%;
  }
}
</style>
